import React, { useEffect } from 'react';
import Aos from 'aos';
import './SplashScreen.css';

function SplashScreen() {
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <div className="splash-screen">
      <div className="logo-container" data-aos="zoom-in">
        <div className="flex flex-col items-center gap-6">
          {/* Main icon */}
          <div className="w-24 h-24 bg-gradient-to-br from-primary via-primary-600 to-primary-700 rounded-2xl flex items-center justify-center shadow-2xl">
            <svg className="w-12 h-12 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path>
            </svg>
          </div>

          {/* Brand name */}
          <div className="text-center">
            <h1 className="text-5xl font-extrabold text-white tracking-tight mb-2">
              Inbox<span className="text-primary-300">IQ</span>
            </h1>
            <p className="text-xl font-medium text-white/80">Adminstrator Portal</p>
          </div>

          {/* Loading indicator */}
          <div className="flex gap-2 mt-4">
            <div className="w-2 h-2 bg-primary-300 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
            <div className="w-2 h-2 bg-primary-300 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
            <div className="w-2 h-2 bg-primary-300 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SplashScreen;